/* ========================================
   WISHFUL TINKERING - SHOPIFY THEME JS
   ======================================== */

(function () {
  'use strict';

  /* ========================================
     MOBILE MENU
     ======================================== */
  const MobileMenu = {
    menu: null,
    overlay: null,
    toggleBtn: null,
    closeBtn: null,
    isOpen: false,

    init() {
      this.menu = document.getElementById('mobile-menu');
      this.overlay = document.getElementById('mobile-menu-overlay');
      this.toggleBtn = document.getElementById('menu-toggle');
      this.closeBtn = document.getElementById('close-menu-btn');

      if (!this.menu || !this.overlay) return;

      this.bindEvents();
    },

    bindEvents() {
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.toggle());
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    },

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      this.isOpen = true;
      this.menu.classList.add('active');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Animate menu items
      const menuLinks = this.menu.querySelectorAll('.menu-link');
      menuLinks.forEach((link, index) => {
        setTimeout(() => {
          link.style.opacity = '1';
          link.style.transform = 'translateX(0)';
          link.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        }, 100 + (index * 100));
      });

      const footerLinks = this.menu.querySelectorAll('.footer-link');
      footerLinks.forEach((link, index) => {
        setTimeout(() => {
          link.style.opacity = '1';
          link.style.transform = 'translateX(0)';
          link.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        }, 400 + (index * 100));
      });
    },

    close() {
      this.isOpen = false;
      this.menu.classList.remove('active');
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';

      // Reset menu items
      const menuLinks = this.menu.querySelectorAll('.menu-link, .footer-link');
      menuLinks.forEach(link => {
        link.style.opacity = '0';
        link.style.transform = 'translateX(-20px)';
      });
    }
  };

  /* ========================================
     BOOK CAROUSEL
     Three-card rotation. Every book block is a real
     .book-card in the stage; this positions them.
     ======================================== */
  const BookCarousel = {
    // Slot geometry, as a percentage of one card's width
    SIDE_X: 46,        // visible left / right cards
    HIDDEN_X: 14,      // cards beyond those, tucked behind centre
    SIDE_SCALE: 0.72,
    HIDDEN_SCALE: 0.68,

    currentIndex: 0,
    stage: null,
    dots: null,
    cards: [],

    init() {
      this.stage = document.querySelector('.carousel-stage');
      if (!this.stage) return;

      this.cards = Array.prototype.slice.call(this.stage.querySelectorAll('.book-card'));
      this.dots = document.querySelectorAll('.carousel-dot');

      if (!this.cards.length) return;

      this.bindEvents();
      this.positionCards();
      this.updateDots();
    },

    getCurrentCard() {
      return this.cards[this.currentIndex];
    },

    // Shortest signed distance from the active card, wrapping both ways
    offsetOf(index) {
      const total = this.cards.length;
      let d = index - this.currentIndex;
      if (d > total / 2) d -= total;
      if (d < -total / 2) d += total;
      return d;
    },

    positionCards() {
      this.cards.forEach((card, i) => {
        const offset = this.offsetOf(i);
        const distance = Math.abs(offset);
        const sign = offset < 0 ? -1 : 1;

        let x, scale, opacity, z, hidden;

        if (distance === 0) {
          x = 0;
          scale = 1;
          opacity = 1;
          z = 30;
          hidden = false;
        } else if (distance === 1) {
          x = sign * this.SIDE_X;
          scale = this.SIDE_SCALE;
          opacity = 1;
          z = 20;
          hidden = false;
        } else {
          // Stacked behind the centre card, ready to slide outward
          x = sign * this.HIDDEN_X;
          scale = this.HIDDEN_SCALE;
          opacity = 0;
          z = 5;
          hidden = true;
        }

        card.style.transform = `translateX(${x}%) scale(${scale})`;
        card.style.opacity = opacity;
        card.style.zIndex = z;
        card.classList.toggle('is-active', distance === 0);
        card.classList.toggle('is-hidden', hidden);
        card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      });
    },

    goToSlide(index) {
      const total = this.cards.length;
      this.currentIndex = ((index % total) + total) % total;
      this.positionCards();
      this.updateDots();
    },

    go(direction) {
      this.goToSlide(this.currentIndex + (direction === 'next' ? 1 : -1));
    },

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    },

    // Follow the centre card's link, or explain why there isn't one
    openCard(card) {
      if (!card) return;

      if (card.dataset.unavailable === 'true') {
        this.showUnavailableToast({
          title: card.dataset.title,
          badge: card.dataset.badge
        });
        return;
      }

      const link = card.dataset.link;
      if (link && link !== '#') {
        window.location.href = link;
      }
    },

    bindEvents() {
      const prevBtn = document.querySelector('.carousel-nav.prev');
      const nextBtn = document.querySelector('.carousel-nav.next');

      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.go('prev'));
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.go('next'));
      }

      if (this.dots) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });
      }

      // Tap a side card to rotate it in; tap the centre card to open it
      this.cards.forEach((card, i) => {
        card.addEventListener('click', (e) => {
          // The Read Now button carries its own link
          if (e.target.closest('.book-read-btn') || e.target.closest('.book-btn')) {
            return;
          }

          if (i !== this.currentIndex) {
            e.preventDefault();
            this.goToSlide(i);
            return;
          }

          this.openCard(card);
        });
      });

      // Touch swipe — swipe left advances, matching the arrows
      let touchStartX = 0;
      let touchStartY = 0;
      let tracking = false;

      this.stage.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].screenX;
        touchStartY = e.touches[0].screenY;
        tracking = true;
      }, { passive: true });

      this.stage.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;

        const touch = e.changedTouches[0];
        const diffX = touchStartX - touch.screenX;
        const diffY = touchStartY - touch.screenY;
        const threshold = 50;

        if (Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY)) {
          this.go(diffX > 0 ? 'next' : 'prev');
        }
      }, { passive: true });

      // Keyboard
      document.addEventListener('keydown', (e) => {
        if (!this.stage.offsetParent) return; // carousel not on screen
        if (e.key === 'ArrowLeft') this.go('prev');
        if (e.key === 'ArrowRight') this.go('next');
      });
    },

    // Show toast message for unavailable books
    showUnavailableToast(book) {
      // Remove any existing toast
      const existingToast = document.querySelector('.book-unavailable-toast');
      if (existingToast) existingToast.remove();

      // Create toast - clean professional style
      const toast = document.createElement('div');
      toast.className = 'book-unavailable-toast';
      toast.innerHTML = `
        <div class="toast-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div class="toast-text">
          <strong>${book.title || 'This book'}</strong>
          <span class="toast-message">Not available yet</span>
          <span class="toast-badge">${book.badge || 'Coming Soon'}</span>
        </div>
      `;
      document.body.appendChild(toast);

      // Animate in
      requestAnimationFrame(() => {
        toast.classList.add('show');
      });

      // Remove after 1.5 seconds
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 1500);
    }
  };

  /* ========================================
     AUDIO PLAYER
     ======================================== */
  const AudioPlayer = {
    isPlaying: false,
    isExpanded: false,
    vinyl: null,
    playBtn: null,
    expandBtn: null,
    progressBar: null,

    init() {
      this.vinyl = document.querySelector('.vinyl-mini');
      this.playBtn = document.querySelector('.play-btn');
      this.expandBtn = document.querySelector('.expand-btn');
      this.progressBar = document.querySelector('.audio-progress-bar');

      if (!this.playBtn) return;

      this.bindEvents();
    },

    bindEvents() {
      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => this.togglePlay());
      }

      if (this.expandBtn) {
        this.expandBtn.addEventListener('click', () => this.toggleExpand());
      }
    },

    togglePlay() {
      this.isPlaying = !this.isPlaying;

      if (this.vinyl) {
        this.vinyl.classList.toggle('playing', this.isPlaying);
      }

      // Update play button icon
      if (this.playBtn) {
        const icon = this.playBtn.querySelector('svg');
        if (icon) {
          if (this.isPlaying) {
            icon.innerHTML = '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>';
          } else {
            icon.innerHTML = '<polygon points="5 3 19 12 5 21 5 3"></polygon>';
          }
        }
      }
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      const expandedPlayer = document.querySelector('.audio-player-expanded');
      if (expandedPlayer) {
        expandedPlayer.classList.toggle('active', this.isExpanded);
      }
    }
  };

  /* ========================================
     SCROLL REVEAL
     ======================================== */
  const ScrollReveal = {
    elements: [],

    init() {
      this.elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');

      if (this.elements.length === 0) return;

      this.checkVisibility();
      window.addEventListener('scroll', () => this.checkVisibility());
    },

    checkVisibility() {
      this.elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight - 100;

        if (isVisible) {
          element.classList.add('active');
        }
      });
    }
  };

  /* ========================================
     FORM HANDLER
     Requirements: 8.2, 8.3, 8.4
     ======================================== */
  const FormHandler = {
    init() {
      const forms = document.querySelectorAll('.contact-form');

      forms.forEach(form => {
        form.addEventListener('submit', (e) => this.handleSubmit(e, form));
      });
    },

    handleSubmit(e, form) {
      const submitBtn = form.querySelector('.submit-btn');
      if (!submitBtn) return;

      // Get customizable text from data attributes
      const originalText = submitBtn.dataset.submitText || submitBtn.textContent;
      const successText = submitBtn.dataset.successText || 'Message Sent!';

      // Show loading state (Requirement 8.2)
      submitBtn.textContent = 'Sending...';
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      // For AJAX submission, prevent default and handle manually
      // For native Shopify form, let it submit normally but show loading state
      if (form.dataset.ajax === 'true') {
        e.preventDefault();
        this.submitAjax(form, submitBtn, originalText, successText);
      } else {
        // Native Shopify form - show loading state briefly
        // The page will reload with success message from Liquid
      }
    },

    submitAjax(form, submitBtn, originalText, successText) {
      const formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(response => {
          if (response.ok) {
            this.showSuccess(form, submitBtn, originalText, successText);
          } else {
            this.showError(form, submitBtn, originalText);
          }
        })
        .catch(() => {
          this.showError(form, submitBtn, originalText);
        });
    },

    showSuccess(form, submitBtn, originalText, successText) {
      // Display success message and checkmark icon (Requirement 8.3)
      submitBtn.classList.remove('loading');
      submitBtn.classList.add('success');
      submitBtn.innerHTML = `<span style="display:flex;align-items:center;justify-content:center;gap:8px;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        ${successText}
      </span>`;

      // Show success message below form
      let successMsg = form.querySelector('.form-success-message');
      if (!successMsg) {
        successMsg = document.createElement('p');
        successMsg.className = 'form-success-message';
        successMsg.innerHTML = `
          <svg class="success-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          Thank you! I'll get back to you soon.
        `;
        form.appendChild(successMsg);
      }

      // Clear form and reset button after delay (Requirement 8.4)
      setTimeout(() => {
        form.reset();
        submitBtn.classList.remove('success');
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        if (successMsg) {
          successMsg.remove();
        }
      }, 3000);
    },

    showError(form, submitBtn, originalText) {
      submitBtn.classList.remove('loading');
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;

      // Show error message
      let errorMsg = form.querySelector('.form-error-message');
      if (!errorMsg) {
        errorMsg = document.createElement('div');
        errorMsg.className = 'form-error-message';
        errorMsg.textContent = 'Something went wrong. Please try again.';
        form.appendChild(errorMsg);
      }

      setTimeout(() => {
        if (errorMsg) {
          errorMsg.remove();
        }
      }, 5000);
    }
  };

  /* ========================================
     BOOK READER
     ======================================== */
  const BookReader = {
    currentPage: 0,
    totalPages: 1,
    pages: [],
    isAnimating: false,

    init() {
      this.container = document.querySelector('.reader-content');
      if (!this.container) return;

      this.pages = document.querySelectorAll('.reader-page');
      this.totalPages = this.pages.length;

      this.bindEvents();
      this.updateDisplay();
    },

    bindEvents() {
      const prevBtn = document.querySelector('.page-btn.prev');
      const nextBtn = document.querySelector('.page-btn.next');

      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.prevPage());
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.nextPage());
      }

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevPage();
        if (e.key === 'ArrowRight') this.nextPage();
      });

      // Touch swipe
      let touchStartX = 0;
      let touchEndX = 0;

      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      });

      this.container.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      });
    },

    handleSwipe(startX, endX) {
      const threshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextPage();
        } else {
          this.prevPage();
        }
      }
    },

    prevPage() {
      if (this.currentPage > 0 && !this.isAnimating) {
        this.animatePage('right');
        this.currentPage--;
        this.updateDisplay();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages - 1 && !this.isAnimating) {
        this.animatePage('left');
        this.currentPage++;
        this.updateDisplay();
      }
    },

    goToPage(pageNum) {
      if (pageNum >= 0 && pageNum < this.totalPages && pageNum !== this.currentPage) {
        const direction = pageNum > this.currentPage ? 'left' : 'right';
        this.animatePage(direction);
        this.currentPage = pageNum;
        this.updateDisplay();
      }
    },

    animatePage(direction) {
      this.isAnimating = true;

      const currentContent = this.container.querySelector('.page-content.active');
      if (currentContent) {
        currentContent.classList.add(`slide-to-${direction === 'left' ? 'left' : 'right'}`);
      }

      setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    },

    updateDisplay() {
      // Update page counter
      const pageCount = document.querySelector('.page-count');
      if (pageCount) {
        pageCount.textContent = `${this.currentPage + 1}/${this.totalPages}`;
      }

      // Update button states
      const prevBtn = document.querySelector('.page-btn.prev');
      const nextBtn = document.querySelector('.page-btn.next');

      if (prevBtn) {
        prevBtn.classList.toggle('disabled', this.currentPage === 0);
        prevBtn.classList.toggle('active', this.currentPage > 0);
      }

      if (nextBtn) {
        nextBtn.classList.toggle('disabled', this.currentPage === this.totalPages - 1);
        nextBtn.classList.toggle('active', this.currentPage < this.totalPages - 1);
      }

      // Show current page content
      this.pages.forEach((page, index) => {
        page.classList.toggle('active', index === this.currentPage);
      });
    }
  };

  /* ========================================
     CHAPTER DROPDOWN
     ======================================== */
  const ChapterDropdown = {
    init() {
      const chapterBtn = document.querySelector('.chapter-dropdown');
      const pageBtn = document.querySelector('.page-dropdown');
      const chapterMenu = document.querySelector('.chapter-menu');
      const pageMenu = document.querySelector('.page-menu');

      if (chapterBtn && chapterMenu) {
        chapterBtn.addEventListener('click', () => {
          chapterMenu.classList.toggle('active');
          if (pageMenu) pageMenu.classList.remove('active');
        });
      }

      if (pageBtn && pageMenu) {
        pageBtn.addEventListener('click', () => {
          pageMenu.classList.toggle('active');
          if (chapterMenu) chapterMenu.classList.remove('active');
        });
      }

      // Close dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.chapter-dropdown') && !e.target.closest('.chapter-menu')) {
          if (chapterMenu) chapterMenu.classList.remove('active');
        }
        if (!e.target.closest('.page-dropdown') && !e.target.closest('.page-menu')) {
          if (pageMenu) pageMenu.classList.remove('active');
        }
      });
    }
  };

  /* ========================================
     PRODUCT CARDS
     ======================================== */
  const ProductCards = {
    init() {
      const cards = document.querySelectorAll('.membership-card, .book-list-item');

      cards.forEach(card => {
        card.addEventListener('click', function () {
          const link = this.dataset.link;
          if (link) {
            window.location.href = link;
          }
        });

        // Add touch feedback
        card.addEventListener('touchstart', function () {
          this.style.transform = 'scale(0.98)';
        });

        card.addEventListener('touchend', function () {
          this.style.transform = '';
        });
      });
    }
  };

  /* ========================================
     MODE SELECTION
     ======================================== */
  const ModeSelection = {
    init() {
      // Mode selection is now handled by inline script in mode-selection.liquid
      // This module is kept for backwards compatibility but does nothing
      // The inline script adds ?mode=read-only or ?mode=read-listen to current URL
    }
  };

  /* ========================================
     SMOOTH SCROLL
     ======================================== */
  const SmoothScroll = {
    init() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    }
  };

  /* ========================================
     SPARKLE TAP EFFECT
     ======================================== */
  const SparkleTap = {
    colors: ['#E8A87C', '#F67280', '#C3AED6', '#95E1D3', '#F9ED69', '#A8D8EA'],

    init() {
      document.addEventListener('click', (e) => this.createSparkle(e));
    },

    createSparkle(e) {
      const container = document.createElement('div');
      container.className = 'sparkle-container';
      container.style.left = e.clientX + 'px';
      container.style.top = e.clientY + 'px';

      // Pick a random color for this tap
      const color = this.colors[Math.floor(Math.random() * this.colors.length)];

      // Exactly 3 sparkles at random positions
      for (let i = 0; i < 3; i++) {
        const star = document.createElement('div');
        star.className = 'sparkle-star';

        // Random position around tap point
        const offsetX = (Math.random() - 0.5) * 50;
        const offsetY = (Math.random() - 0.5) * 50;
        star.style.left = offsetX + 'px';
        star.style.top = offsetY + 'px';

        // Size 12-20px
        const size = 12 + Math.random() * 8;
        star.style.animationDelay = (i * 0.05) + 's';
        star.innerHTML = this.createStarSVG(size, color);

        container.appendChild(star);
      }

      document.body.appendChild(container);

      setTimeout(() => {
        container.remove();
      }, 700);
    },

    createStarSVG(size, color) {
      // Sharp 4-point star
      return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${color}">
        <path d="M12 0 L13 10 L24 12 L13 14 L12 24 L11 14 L0 12 L11 10 Z"/>
      </svg>`;
    }
  };

  /* ========================================
     LAZY LOADING
     ======================================== */
  const LazyLoad = {
    init() {
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src;
              img.classList.add('loaded');
              observer.unobserve(img);
            }
          });
        });

        document.querySelectorAll('img[data-src]').forEach(img => {
          imageObserver.observe(img);
        });
      }
    }
  };

  /* ========================================
     DESKTOP NAVIGATION ACTIVE STATE
     ======================================== */
  const DesktopNav = {
    init() {
      const navLinks = document.querySelectorAll('.desktop-nav-link');
      if (!navLinks.length) return;

      const currentPath = window.location.pathname;

      navLinks.forEach(link => {
        const linkPath = new URL(link.href).pathname;

        // Check if current page matches this link
        if (currentPath === linkPath) {
          link.classList.add('active');
        }
        // Special case: Books collection or book products
        else if (linkPath.includes('/collections/books') &&
          (currentPath.includes('/collections/books') ||
            currentPath.includes('/products/'))) {
          link.classList.add('active');
        }
        // Special case: Contact page
        else if (linkPath.includes('/pages/contact') &&
          currentPath.includes('/pages/contact')) {
          link.classList.add('active');
        }
        // Special case: Homepage
        else if (linkPath === '/' && currentPath === '/') {
          link.classList.add('active');
        }
      });
    }
  };

  /* ========================================
     INITIALIZATION
     ======================================== */
  document.addEventListener('DOMContentLoaded', function () {
    MobileMenu.init();
    BookCarousel.init();
    AudioPlayer.init();
    ScrollReveal.init();
    FormHandler.init();
    BookReader.init();
    ChapterDropdown.init();
    ProductCards.init();
    ModeSelection.init();
    SmoothScroll.init();
    LazyLoad.init();
    SparkleTap.init();
    DesktopNav.init();

    console.log('Wishful Tinkering theme initialized');
  });

})();
